// import store from "@/store/store";
// import BeCuponUtils from "@/utils/Utils";

export default class Promotion {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query{
          promotionRetrieve(id:${id}){
            id
            name
            description
            image {
                id
                url
              }
            loyaltyCampaign{
              id
              name
              active
              dateStart
              dateEnd
            }
          }
        }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    response.data.data.promotionRetrieve.loyaltyCampaign = response.data.data.promotionRetrieve.loyaltyCampaign.id

    return response.data.data.promotionRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        promotionList{
          results{
            id
            name
            description
            loyaltyCampaign{
              id
              name
              active
              dateStart
              dateEnd
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.promotionList.results.reverse();
  }

  // static async filter(axios, active) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       couponList (active: ${active}){
  //         results{
  //           id
  //           isActive
  //           available
  //           amountCompleted
  //           amountActives
  //           title
  //           expirationDate
  //           globalTotalUses
  //           globalUses
  //           inWallet
  //           globalActives
  //           images {
  //             id
  //             url
  //           }
  //           initialDate
  //           dailyUses
  //           totalUses
  //           showApp
  //           assignedCoupon
  //           qrText
  //           company{
  //             id
  //             name
  //           }
  //           qrValidationCode
  //           qrValidationCodeUses
  //           totalClick
  //           qrBarcode {
  //             id
  //             url
  //           }
  //           coupons{
  //             id
  //             title
  //           }
  //           branchOffices{
  //             id
  //             name
  //           }
  //           couponsUses{
  //             id
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //
  //   return response.data.data.couponList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deletePromotion ($id: ID!){
          deletePromotion(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deletePromotion.ok;
  }
}
